import { Flex, FlexProps, useDisclosure } from '@chakra-ui/react'
import React, { createContext } from 'react'
interface SidebarProps extends FlexProps {
  defaultIsOpen?: boolean
  shrinkHeight?: string | string[]
  shrinkWidth?: string | string[]
  toggleControl?: React.ReactElement
}

export interface SidebarContextType {
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
}

export const SidebarContext = createContext<SidebarContextType>({
  isOpen: false,
  onClose() {
    /* No operation */
  },
  onOpen() {
    /* No operation */
  },
})

export const Sidebar: React.FC<SidebarProps> = ({
  children,
  defaultIsOpen,
  height,
  shrinkHeight,
  shrinkWidth,
  toggleControl,
  width,
  ...rest
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure({ defaultIsOpen })

  return (
    <SidebarContext.Provider value={{ isOpen, onClose, onOpen }}>
      <Flex
        background="white"
        direction="column"
        flexShrink={0}
        height={isOpen ? height || '100vh' : shrinkHeight || '100vh'}
        overflowX="hidden"
        position="relative"
        top="-40px"
        transition="width ease-in-out 500ms"
        width={isOpen ? width || '295px' : shrinkWidth || '80px'}
        {...rest}
      >
        {toggleControl &&
          React.cloneElement(toggleControl, {
            isOpen,
            onClick: isOpen ? onClose : onOpen,
          })}
        <Flex
          opacity={isOpen ? 1 : 0}
          position="relative"
          transition="opacity 500ms ease-in-out"
        >
          {children}
        </Flex>
      </Flex>
    </SidebarContext.Provider>
  )
}
